module.exports = __webpack_public_path__ + "static/media/landmark.ce384a7d.svg";